module.exports = __webpack_public_path__ + "static/img/wjk.7c3e8b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wjk.png
// module id = PW9L
// module chunks = 1